/** API route map: URLS.Controller.BlobStorage */
export const BlobStorage = {
      Name: 'AzureStorage/',
      // Anonymous, and no longer called from anywhere in this app - every in-app download moved to
      // DownloadFileWithAuth below. Left here only so the constant does not disappear from under
      // any external caller; the backend route itself still needs locking down.
      Download: 'download',
      // Anonymous by necessity: fetches company branding on the login screen, before a token exists.
      // Reads the SSO container on the public account.
      DownloadSSO: 'downloadSSO',
      // Authenticated equivalent of `download` - same public-then-private fallback, but behind the
      // controller's [Authorize]. Every in-app file download uses this now that post-login files
      // live in the private container.
      DownloadFileWithAuth: 'download-file',
};
